import t from 'tcomb';
import Locale from './Locale';
import Currency from './Currency';

const Amount = t.refinement(t.Num, (n) => n >= 0);

Amount.format = function(locale: Locale, currency: Currency, amount: Amount): t.String {
  const bundle = locale.locale_bundle();
  t.assert(t.Object.is(bundle));
  const symbol = bundle.currency[currency];
  return symbol + ' ' + locale.format_number(amount);
};

export default Amount;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Amount.js
 **/